<template>
  <div class="FlipNumber" v-show="position.show">
    <Flipper :ref="'flip' + index" v-for="(n, index) in option.number" :styleConfig="option.style" :key="n" />
  </div>
</template>

<script>
import Flipper from './Flipper'

export default {
  name: 'FlipNumber',
  data() {
    return {
      initFlip: 0, // 初始化翻牌器数量
      initNumber: [], // 初始化数字
      flipNumber: null, // 翻页数字
      flipObjs: [] // 翻牌器对象
    }
  },
  props: {
    option: {
      type: Object,
      default: null
    },
    position: {
      type: Object,
      default: null
    }
  },
  components: {
    Flipper
  },
  methods: {
    // 定时刷新数据
    run() {
      this.flipObjs = []
      this.initFlip = this.option.number
      this.flipNumber = this.option.data
      if (this.flipNumber.length < this.initFlip) {
        // 小于初始化翻牌器数量前位补零
        this.flipNumber = (Array(this.initFlip).join('0') + this.flipNumber).slice(-this.initFlip)
      }
      this.initNumber = new Array(this.initFlip).fill(0)
      for (let i = 0; i < this.initFlip; i++) {
        this.flipObjs.push(this.$refs['flip' + i])
      }
      // 获取当前数组
      for (let i = 0; i < this.initFlip; i++) {
        if (this.initNumber[i] === this.flipNumber[i]) {
          continue
        }
        if (this.flipObjs[i]) {
          this.flipObjs[i][0].flipDown(this.initNumber[i], this.flipNumber[i])
        }
      }
    },
    // 重绘大小
    resize(w, h) {
      console.log(w, h)
    }
  },
  mounted() {
    this.run()
  },
  watch: {
    'option.data'(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        setTimeout(() => {
          this.run()
        }, 500)
      }
    }
  }
}
</script>

<style scoped lang="less">
.FlipNumber {
  text-align: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.FlipNumber .M-Flipper {
  margin: 0 3px;
}
</style>
